import { IconPropsType } from '..';

export const SwitchOffIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.00002 7.90322C7.41232 7.90322 7.74669 7.57964 7.74669 7.18064V2.12257C7.74669 1.72357 7.41232 1.39999 7.00002 1.39999C6.58772 1.39999 6.25336 1.72357 6.25336 2.12257V7.18064C6.25336 7.58032 6.58702 7.90322 7.00002 7.90322ZM10.4464 2.90861C10.1216 2.66383 9.65232 2.71879 9.39822 3.0328C9.14412 3.34757 9.20134 3.80122 9.52619 4.04757C10.5304 4.80741 11.1067 5.94999 11.1067 7.18064C11.1067 9.37164 9.26452 11.1548 7.00002 11.1548C4.73552 11.1548 2.89336 9.37096 2.89336 7.18064C2.89336 5.94932 3.46946 4.80741 4.47349 4.04645C4.79829 3.80009 4.85569 3.34645 4.60145 3.03167C4.34688 2.71757 3.87812 2.6627 3.55332 2.90748C2.18496 3.94483 1.40002 5.5029 1.40002 7.18064C1.40002 10.1681 3.91302 12.6 7.00002 12.6C10.087 12.6 12.6 10.1681 12.6 7.18064C12.6 5.5029 11.816 3.94483 10.4464 2.90861Z"
      fill="#B4E4FF"
    />
  </svg>
);
